import Konva from 'konva';
import { MEASUREMENT_LABELS } from './soil-survey-constants';

export const getMeasurementLabel = (code: string) => {
    return MEASUREMENT_LABELS[code] || code;
};

export const calculateOptimalStepSize = (maxValue: number, targetSteps = 7): { stepSize: number; stepCount: number } => {
    if (maxValue <= 0) return { stepSize: 0, stepCount: 0 };

    const niceSteps = [1, 2, 5];
    for (let i = 1; i <= 100; i++) {
        niceSteps.push(i * 10);
    }

    // Find the step size that gives closest to targetSteps
    let bestStep = niceSteps[0];
    let bestStepCount = Math.ceil(maxValue / bestStep);
    let bestDifference = Math.abs(bestStepCount - targetSteps);

    for (const step of niceSteps) {
        const stepCount = Math.ceil(maxValue / step);
        const difference = Math.abs(stepCount - targetSteps);

        if (difference < bestDifference) {
            bestStep = step;
            bestStepCount = stepCount;
            bestDifference = difference;
        }

        // Perfect match found
        if (difference === 0) break;

        // Stop if steps are getting too few (optimization)
        if (stepCount < targetSteps - 2) break;
    }

    return { stepSize: bestStep, stepCount: bestStepCount };
};

export const getSoilLayerColor = (soilType: string): string => {
    /*
        TODO:
        - Figure out the standard color scheme for the soil types
    */

    if (soilType === 'Sr') return '#8B4513';
    if (soilType === 'hSr') return '#A0522D';
    if (soilType === 'keSr') return '#8B4513';
    if (soilType === 'kaSr') return '#654321';
    if (soilType === 'hkSr') return '#D2691E';
    if (soilType === 'huSr') return '#5D4037';

    if (soilType === 'Hk') return '#F4A460';
    if (soilType === 'hHk') return '#F5DEB3';
    if (soilType === 'keHk') return '#F4A460';
    if (soilType === 'kaHk') return '#CD853F';
    if (soilType === 'srHk') return '#DEB887';
    if (soilType === 'siHk') return '#D2B48C';
    if (soilType === 'huHk') return '#BC8F8F';

    if (soilType === 'Mr') return '#708090';
    if (soilType === 'SrMr') return '#778899';
    if (soilType === 'hkSrMr') return '#8A8A8A';
    if (soilType === 'HkMr') return '#696969';
    if (soilType === 'siHkMr') return '#A9A9A9';
    if (soilType === 'srHkMr') return '#808080';
    if (soilType === 'huHkMr') return '#556B2F';
    if (soilType === 'SiMr') return '#B0C4DE';
    if (soilType === 'hkSiMr') return '#C0C0C0';
    if (soilType === 'huSiMr') return '#6B8E23';

    if (soilType === 'Si') return '#D2B48C';
    if (soilType === 'hSi') return '#F5F5DC';
    if (soilType === 'keSi') return '#D2B48C';
    if (soilType === 'kaSi') return '#BDB76B';
    if (soilType === 'hkSi') return '#DDD0A0';
    if (soilType === 'saSi') return '#DAA520';
    if (soilType === 'ljSi') return '#B8860B';

    if (soilType === 'Sa') return '#B22222';
    if (soilType === 'laSa') return '#CD5C5C';
    if (soilType === 'liSa') return '#A0522D';
    if (soilType === 'ljSa') return '#8B4513';

    if (soilType === 'Lj') return '#654321';
    if (soilType === 'siLj') return '#8B7355';
    if (soilType === 'saLj') return '#A0522D';

    if (soilType === 'Tv') return '#2F4F2F';
    if (soilType === 'RTv') return '#556B2F';
    if (soilType === 'KTv') return '#3C341F';
    if (soilType === 'MTv') return '#1C1C1C';

    if (soilType === 'Mu') return '#654321';
    if (soilType === 'Hm') return '#8B4513';

    if (soilType === 'Ta') return '#555555';
    if (soilType === 'Ki') return '#444444';
    if (soilType === 'Ka') return '#2F3542';

    return '';
};

export const drawBars = (layer: Konva.Layer, x1: number, x2: number, y1: number, y2: number, lineOptions?: Partial<Konva.LineConfig>) => {
    /*
    const horizontalLine = new Konva.Line({
        points: [x1, y1, x2, y1],
        stroke: 'black',
        strokeWidth: 1.0,
        ...lineOptions
    });
    layer.add(horizontalLine);

    const verticalLine = new Konva.Line({
        points: [x2, y1, x2, y2],
        stroke: 'black',
        strokeWidth: 1.0,
        ...lineOptions
    });
    layer.add(verticalLine);
    */
    const verticalLine = new Konva.Line({
        points: [x1, y1, x1, y2],
        stroke: 'black',
        strokeWidth: 1.0,
        ...lineOptions,
    });
    layer.add(verticalLine);
    const horizontalLine = new Konva.Line({
        points: [x1, y2, x2, y2],
        stroke: 'black',
        strokeWidth: 1.0,
        ...lineOptions,
    });
    layer.add(horizontalLine);
};

export const drawLine = (layer: Konva.Layer, x1: number, x2: number, y1: number, y2: number, lineOptions?: Partial<Konva.LineConfig>) => {
    const defaultOptions: Konva.LineConfig = {
        points: [x1, y1, x2, y2],
        stroke: 'black',
        strokeWidth: 1.0,
    };

    const finalOptions = { ...defaultOptions, ...lineOptions };

    const line = new Konva.Line(finalOptions);
    layer.add(line);
};
